module.exports = __webpack_public_path__ + "static/media/check_circle-24px.3f5414d1.svg";